import { DotsVerticalIcon, Paragraph } from "@datagame/ui";
import { Menu } from "@headlessui/react";
import { ReactNode } from "react";
import classNames from "classnames/bind";

import styles from "./Dropdown.module.scss";

const cx = classNames.bind(styles);

export interface DropdownOption {
  icon?: ReactNode;
  onClick?: () => void;
  name: string;
  className?: string;
}

export interface DropdownProps {
  options: DropdownOption[];
}

export const Dropdown = ({ options }: DropdownProps) => {
  return (
    <div className={styles.dropdownWrapper}>
      <Menu>
        <Menu.Button className={styles.button}>
          <DotsVerticalIcon />
        </Menu.Button>
        <Menu.Items className={styles.list}>
          {options.map((option, index) => {
            return (
              <Menu.Item key={index}>
                {() => (
                  <div onClick={option.onClick} onKeyDown={option.onClick} role="button" tabIndex={0}>
                    <Paragraph className={cx("item", option.className)} size="small">
                      <div className={styles.icon}>{option.icon}</div>
                      {option.name}
                    </Paragraph>
                  </div>
                )}
              </Menu.Item>
            );
          })}
        </Menu.Items>
      </Menu>
    </div>
  );
};
